import { fieldLabel, type ViolationTarget } from '@/features/moderation/lib/violationRef'
import { messagesNow } from '@/i18n'
import { messages } from './messages'

// Колонки статьи в `ref` (контракт §4): RU-слот — `name`/`text`, EN — `title_en`/`content_en`
// (суффикс `_en` снимает `parseViolationRef`). Общий словарь `fieldLabel` назвал бы `name`
// «Названием», а EN-пару «Заголовком», и один заголовок выглядел бы двумя разными полями.
// Только колонки контракта: подпись любой другой (оформление и т.п.) была бы догадкой.
const articleFields = () => {
  const m = messagesNow(messages)
  return new Map([
    ['name', m.fieldTitle],
    ['title', m.fieldTitle],
    ['text', m.fieldContent],
    ['content', m.fieldContent],
  ])
}

/** Подпись места нарушения статьи; незнакомое — сырым `ref`, без угаданного перевода. */
export const articleViolationLabel = (target: ViolationTarget, ref: string): string => {
  const m = messagesNow(messages)
  if (target.kind === 'image') return m.image
  const labels = articleFields()
  if (target.kind !== 'article' || !labels.has(target.field.name)) return ref
  const field = fieldLabel(target.field, labels)
  // Номер ссылки — с единицы: автор считает ссылки в тексте, а не индексы.
  return target.linkIndex === null ? field : m.linkN(field, target.linkIndex + 1)
}
